import { useMemo } from "react"

interface SearchNameFilterBarProps {
   setSearchText: (text: string) => void
   placeholder?: string
}

export function SearchNameFilterBar({
   setSearchText,
   placeholder = "Rechercher par nom...",
}: SearchNameFilterBarProps) {
   const handleChange = useMemo(() => {
      return (e: React.ChangeEvent<HTMLInputElement>) => {
         setSearchText(e.target.value.toLowerCase())
      }
   }, [setSearchText])

   return (
      <div className="relative w-full px-2">
         <div className="absolute inset-y-0 left-0 flex items-center pl-6 pointer-events-none">
            <svg
               className="w-4 h-4 text-gray-500"
               aria-hidden="true"
               xmlns="http://www.w3.org/2000/svg"
               fill="none"
               viewBox="0 0 20 20"
            >
               <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
               />
            </svg>
         </div>
         <input
            type="text"
            className="input input-bordered pl-10 w-full "
            placeholder={placeholder}
            onChange={handleChange}
         />
      </div>
   )
}
